import { Button, App } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import type { GlossaryTerm } from '@/types/glossary';

interface Props {
  terms: GlossaryTerm[];
}

export function ExportCsvButton({ terms }: Props) {
  const { message } = App.useApp();
  function download() {
    const langs = Array.from(
      new Set(terms.flatMap((t) => t.translations.map((tr) => tr.lang_code))),
    ).sort();
    const header = ['term', 'preserve_as_is', 'notes', ...langs];
    const rows = terms.map((t) => {
      const byLang: Record<string, string> = {};
      for (const tr of t.translations) byLang[tr.lang_code] = tr.translation;
      return [
        t.term,
        String(t.preserve_as_is),
        t.notes ?? '',
        ...langs.map((l) => byLang[l] ?? ''),
      ];
    });
    const csv = [header, ...rows]
      .map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(','))
      .join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `glossary-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
    message.success('Exported');
  }

  return (
    <Button icon={<DownloadOutlined />} onClick={download} disabled={terms.length === 0}>
      Export CSV
    </Button>
  );
}
